import React, { useEffect, useState } from 'react';
import StakeholdersParticipationsTree from './StakeholdersParticipationsTree.jsx';
import StakeholdersParticipationsTable from './StakeholdersParticipationsTable/index.jsx';
import styles from './StakeholdersParticipations.module.css';

const StakeholdersParticipations = (props) => {
  const {
    activeStakeholderParticipationId,
    stakeholdersParticipations,
    organization,
  } = props;
  const [currentLevelStakeholders, setCurrentLevelStakeholders] = useState([]);

  const findStakeholder = (currentId) =>
    stakeholdersParticipations.find(({ id }) => id === currentId);

  const updateCurrentLevelStakeholders = (currentId) => {
    const stakeholder = findStakeholder(currentId);
    if (currentId && stakeholder) {
      setCurrentLevelStakeholders(
        stakeholder.children.length ? stakeholder.children : [stakeholder]
      );
    } else setCurrentLevelStakeholders(stakeholdersParticipations);
  };

  const tableTitle = () => {
    const stakeholder = findStakeholder(activeStakeholderParticipationId);

    if (!activeStakeholderParticipationId || !stakeholder) {
      return organization.name;
    }
    return stakeholder.name;
  };
  useEffect(() => {
    updateCurrentLevelStakeholders(activeStakeholderParticipationId);
  }, [activeStakeholderParticipationId, stakeholdersParticipations]);

  return (
    <React.Fragment>
      <div className={styles.initiativeParticipations}>
        <div
          className={`${styles.initiativeParticipationTree} component component-bg-white component-border-right component-border-bottom`}
        >
          <StakeholdersParticipationsTree {...props} />
        </div>
        <div className="flex-1 component-bg-white component-border-bottom">
          <div className="component flex flex-justify flex-1">
            <h4>{tableTitle()}</h4>
          </div>
          <StakeholdersParticipationsTable
            {...props}
            stakeholdersParticipations={currentLevelStakeholders}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default StakeholdersParticipations;
